// Leadflow authors talk tracks in a Leadflow-flavoured markdown dialect. Its one
// non-CommonMark extension that appears in live content is the colour span
// `{#rrggbb}…{/}`, which leadflow's own renderer turns into a coloured `<span>`
// (see leadflow `src/domain/cold-calling-sheets/lib/render-markdown.ts`). The
// cockpit renders talk tracks with stock CommonMark react-markdown, which has no
// notion of that syntax — so it prints the raw `{#990000}` / `{/}` delimiters as
// literal text scattered through the panel (spoken lines and coaching notes are
// each wrapped in a span), which reads as garbled output rather than a script.
//
// Strip the delimiters, keeping the text they wrap — that text is ordinary
// **bold** (spoken lines) / _italic_ (coaching notes) markdown, so the script
// still renders with the say-it-vs-note distinction intact. We deliberately do
// NOT reproduce the colour itself: react-markdown renders no raw HTML here (the
// panel's XSS-free contract), and the bold/italic already carry the distinction.
const COLOR_SPAN_OPEN = /\{#[0-9a-fA-F]{3,8}\}/g;
const COLOR_SPAN_CLOSE = /\{\/\}/g;

export function sanitizeTalkTrackMarkdown(markdown: string): string {
  return markdown.replace(COLOR_SPAN_OPEN, '').replace(COLOR_SPAN_CLOSE, '');
}
